import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Note } from "../components/Note";
import { API } from "../core/api";
import { Form } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import { formatAntdJalaliDate, onChangeProvince } from "../core/utils";
import { parse, stringify } from "query-string";
import FileSaver from "file-saver";
const useBuyProductReport = () => {
  const history = useHistory();
  const location = useLocation();
  const params = parse(location.search);
  const store = useSelector((state) => state.Store);
  const provinces = useSelector((state) => state.Store.provinces);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState([]);
  const [categories, setCategories] = useState([]);
  const [buyProductReport, setBuyProductReport] = useState([
    {
      id: 5001800,
      user: {
        id: 6009585,
        first_name: "Hussam",
        last_name: "Al-Zahrani",
        driver_phone_number: "0501166195",
      },
      product: {
        name: "Toyota Oil Filter for Hilux",
        category: "Oil",
      },
      quantity: 1,
      payable_amount: 125.5,
      used: 0,
      address: {
        city: "Riyadh",
        province: "Riyadh",
      },
      phone_number: "0112345678",
      purchase_date: {
        purchase_date: "2023/05/21",
        next_purchase_date: "2023/06/20",
        delay_in_purchase: "",
      },
      user_car: {
        car_name: "Toyota Hilux",
        plate_number: "ب ج ح ٧٨٩٠ / B J H 7890",
        initial_km: 0,
      },
      service_center: {
        name: "Al-Rajhi Auto Service",
        phone_number: "0112345678",
        address: "Riyadh - Olaya District - King Fahd Road",
      },
      operator: {
        operator_id: 5001123,
        operator_name: "Mohammed Al-Saud",
        operator_username: "0501234567",
      },
      delivery_date: "2023/05/21",
    },
    {
      id: 5001801,
      user: {
        id: 6009586,
        first_name: "Fatima",
        last_name: "Al-Ghamdi",
        driver_phone_number: "0559876543",
      },
      product: {
        name: "Hyundai Air Filter for Accent",
        category: "Air",
      },
      quantity: 2,
      payable_amount: 89.0,
      used: 1,
      address: {
        city: "Jeddah",
        province: "Makkah",
      },
      phone_number: "0123456789",
      purchase_date: {
        purchase_date: "2024/11/01",
        next_purchase_date: "2024/12/01",
        delay_in_purchase: "3 days",
      },
      user_car: {
        car_name: "Hyundai Accent",
        plate_number: "د س ك ٤٥٦٧ / D S K 4567",
        initial_km: 45000,
      },
      service_center: {
        name: "Jeddah Express Lube",
        phone_number: "0123456789",
        address: "Jeddah - Al-Hamra - Prince Sultan St",
      },
      operator: {
        operator_id: 5004567,
        operator_name: "Fatima Al-Ghamdi",
        operator_username: "0559876543",
      },
      delivery_date: "2024/11/02",
    },
    {
      id: 5001802,
      user: {
        id: 6009587,
        first_name: "Ahmad",
        last_name: "Al-Otaibi",
        driver_phone_number: "0531122334",
      },
      product: {
        name: "Isuzu Brake Pads for NPR",
        category: "Brakes",
      },
      quantity: 1,
      payable_amount: 380.0,
      used: 0,
      address: {
        city: "Dammam",
        province: "Eastern Province",
      },
      phone_number: "0134567890",
      purchase_date: {
        purchase_date: "2022/03/15",
        next_purchase_date: "2022/04/14",
        delay_in_purchase: "",
      },
      user_car: {
        car_name: "Isuzu NPR",
        plate_number: "ر ع ل ٠٠١٢ / R A L 0012",
        initial_km: 120000,
      },
      service_center: {
        name: "Eastern Fleet Maintenance",
        phone_number: "0134567890",
        address: "Dammam - Industrial Area 2",
      },
      operator: {
        operator_id: 5007890,
        operator_name: "Ahmad Al-Zahrani",
        operator_username: "0531122334",
      },
      delivery_date: "2022/03/16",
    },
    {
      id: 5001803,
      user: {
        id: 6009588,
        first_name: "Khalid",
        last_name: "Al-Harbi",
        driver_phone_number: "0594455667",
      },
      product: {
        name: "Nissan Fuel Filter for Patrol",
        category: "Fuel",
      },
      quantity: 1,
      payable_amount: 210.75,
      used: 0,
      address: {
        city: "Mecca",
        province: "Makkah",
      },
      phone_number: "0129876543",
      purchase_date: {
        purchase_date: "2025/01/10",
        next_purchase_date: "2025/02/09",
        delay_in_purchase: "",
      },
      user_car: {
        car_name: "Nissan Patrol",
        plate_number: "ق ه م ٣٣٣٣ / Q H M 3333",
        initial_km: 85000,
      },
      service_center: {
        name: "Makkah Auto Care Center",
        phone_number: "0129876543",
        address: "Mecca - Al-Aziziyah District",
      },
      operator: {
        operator_id: 5002233,
        operator_name: "Khalid Al-Otaibi",
        operator_username: "0594455667",
      },
      delivery_date: "2025/01/11",
    },
    {
      id: 5001804,
      user: {
        id: 6009589,
        first_name: "Nora",
        last_name: "Al-Qahtani",
        driver_phone_number: "0547788990",
      },
      product: {
        name: "Mercedes Coolant 5L",
        category: "Cooling",
      },
      quantity: 3,
      payable_amount: 450.0,
      used: 2,
      address: {
        city: "Madinah",
        province: "Madinah",
      },
      phone_number: "0145678901",
      purchase_date: {
        purchase_date: "2024/09/30",
        next_purchase_date: "2024/10/30",
        delay_in_purchase: "5 days",
      },
      user_car: {
        car_name: "Mercedes-Benz Sprinter",
        plate_number: "ط ن و ٩٩٩٩ / T N W 9999",
        initial_km: 98000,
      },
      service_center: {
        name: "Madinah Commercial Vehicles",
        phone_number: "0145678901",
        address: "Madinah - Qiblatain Road",
      },
      operator: {
        operator_id: 5009900,
        operator_name: "Nora Al-Harbi",
        operator_username: "0547788990",
      },
      delivery_date: "2024/10/05",
    },
  ]);
  const [search, setSearch] = useState(params.search || "");
  const [form] = Form.useForm();

  const getUsers = (province_id, city_id) => {
    const filters = {
      province_id: province_id ? province_id : null,
      city_id: city_id ? city_id : null,
    };
    // API.get.company_employee(filters).then((response) => {
    //   if (response.success) {
    //     setUsers(response.data);
    //   }
    // });
  };

  const getBuyProductReport = (page, disableFilters = false) => {
    // setLoading(true);
    const {
      purchase_date,
      city_id,
      operator_id,
      product_category_id,
      province_id,
      min_product_price,
      max_product_price,
    } = form.getFieldsValue();
    const form_purchase_start_date =
      purchase_date &&
      purchase_date?.length &&
      purchase_date[0] &&
      typeof purchase_date[0] === "object"
        ? formatAntdJalaliDate(purchase_date[0])
        : purchase_date
        ? purchase_date[0]
        : null;

    const form_purchase_end_date =
      purchase_date &&
      purchase_date.length &&
      purchase_date[1] &&
      typeof purchase_date[1] === "object"
        ? formatAntdJalaliDate(purchase_date[1])
        : purchase_date
        ? purchase_date[1]
        : null;

    const filters = {
      search,
      ...((page || buyProductReport?.pagination) && {
        page: page || buyProductReport.pagination.page,
      }),
      city_id,
      operator_id:
        store?.user?.user_type === "company_employee"
          ? store?.user?.id
          : operator_id,
      product_category_id,
      province_id,
      min_product_price: min_product_price
        ? min_product_price.replace(/,/g, "")
        : null,
      max_product_price: max_product_price
        ? max_product_price.replace(/,/g, "")
        : null,
      purchase_start_date: form_purchase_start_date,
      purchase_end_date: form_purchase_end_date,
    };
    if (!disableFilters)
      history.push({
        pathname: "/buy-product-report/",
        search: stringify(filters),
      });
    // API.get
    //   .buy_product_report(disableFilters ? {} : filters)
    //   .then((response) => {
    //     if (response.success) {
    //       setBuyProductReport(response);
    //     } else {
    //       Note.error(response.message);
    //     }
    //     setLoading(false);
    //   });
  };

  const exportBuyProductReport = () => {
    const {
      purchase_date,
      city_id,
      operator_id,
      product_category_id,
      province_id,
      min_product_price,
      max_product_price,
    } = form.getFieldsValue();

    const form_purchase_start_date =
      purchase_date &&
      purchase_date?.length &&
      purchase_date[0] &&
      typeof purchase_date[0] === "object"
        ? formatAntdJalaliDate(purchase_date[0])
        : purchase_date
        ? purchase_date[0]
        : null;

    const form_purchase_end_date =
      purchase_date &&
      purchase_date.length &&
      purchase_date[1] &&
      typeof purchase_date[1] === "object"
        ? formatAntdJalaliDate(purchase_date[1])
        : purchase_date
        ? purchase_date[1]
        : null;

    const filters = {
      search,
      ...(buyProductReport?.pagination && {
        page: buyProductReport.pagination.page,
      }),
      city_id,
      operator_id:
        store?.user?.user_type === "company_employee"
          ? store?.user?.id
          : operator_id,
      product_category_id,
      province_id,
      min_product_price: min_product_price
        ? min_product_price.replace(/,/g, "")
        : null,
      max_product_price: max_product_price
        ? max_product_price.replace(/,/g, "")
        : null,
      purchase_start_date: form_purchase_start_date,
      purchase_end_date: form_purchase_end_date,
      get_report: true,
    };
    // API.get.export_buy_product_report(filters).then((response) => {
    //   if (response.status === 200) {
    //     return response.blob();
    //   } else {
    //     Note.error(response.message);
    //   }
    // }).then((blob) => {
    //   FileSaver.saveAs(blob, `buy-product-report.xlsx`);
    // })
  };

  const getCategories = () => {
    // API.get
    //   .product_categories()
    //   .then((response) => {
    //     if (response.success) {
    //       setCategories(response.data);
    //     } else {
    //       Note.error(response.message);
    //     }
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //   });
  };

  const changePage = (page) => {
    setBuyProductReport({
      ...buyProductReport,
      pagination: {
        ...buyProductReport.pagination,
        page,
      },
    });
    getBuyProductReport(page);
  };

  useEffect(() => {
    getBuyProductReport();
    getCategories();
    if (store?.user?.user_type !== "company_employee") getUsers();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (params.province_id && !cities.length) {
      onChangeProvince(params.province_id, null, setCities);
    }
    // eslint-disable-next-line
  }, [history]);

  return {
    loading,
    buyProductReport,
    getBuyProductReport,
    provinces,
    users,
    cities,
    setCities,
    categories,
    form,
    setSearch,
    changePage,
    getUsers,
    exportBuyProductReport,
  };
};

export default useBuyProductReport;
